var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "month" }, [
    _c("table", { staticClass: "table-striped table table-responsive-xl" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.equipments, function (item, index) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(item.type))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.description))]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticStyle: { float: "right" } }, [
                  _vm._v(_vm._s(_vm._f("format_price")(item.price))),
                ]),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.comment))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.init_name))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.cluster_name))]),
            ])
          }),
          _vm._v(" "),
          _vm.equipments.length == 0
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { "text-align": "center", padding: "20px" },
                    attrs: { colspan: "12" },
                  },
                  [_vm._v("Оргтехніки немає")]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Тип")]),
        _vm._v(" "),
        _c("th", [_vm._v("Характеристики")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ціна")]),
        _vm._v(" "),
        _c("th", [_vm._v("Коментар")]),
        _vm._v(" "),
        _c("th", [_vm._v("Відповідальний")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кластер")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }